const __DEV__ = true;

export class Log {

    static log(...items: any[]) {
        if(__DEV__) {
            console.log(items);
        }
    }

    static warn(...items: any[]) {
        if(__DEV__) {
            console.warn(items);
        }
    }

    static warnAlways(...items: any[]) {
        console.warn(items);
    }

    static die(...items: any[]) {
        console.warn(items);
        throw new Error("Engine died through self algorithm requirement.");
    }
}
